import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';
import { Location } from '../models/Location';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  private baseUrl: string = '';
  private apiController: string = '';
  private appConfig!: AppConfigurations;

  constructor(private http: HttpClient, private appInitService: AppInitService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }
  private _onReceiveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.appointmentApi.baseApiUrl;
    this.apiController = this.appConfig.appointmentApi.appointmentController;   
  }
  updateAppointmentStatus(confirmationNumber: string, status: string): Observable<string> {
    return this.http.patch<string>(`${this.baseUrl}${this.apiController}/${confirmationNumber}/status/${status}`, {})
      .pipe(
        tap(data => console.log('updateAppointmentStatus: ' + data)),
        catchError(this.handleError)
      );
  }
  getLocationsWithActiveAppointments(): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.baseUrl}${this.apiController}/locationsactiveappointment`)
      .pipe(
        catchError(this.handleError)
      );
  }


  private handleError(err: any) {
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }
}
